<template>
  <div class="teacher-edit">
    <div class="title">基本信息</div>
    <Form
      class="form"
      ref="form"
      :model="form"
      :rules="formRules"
      label-position="right"
      :label-width="120"
    >
      <FormItem label="助教名称：" prop="real_name" class="form-name">
        <Input v-model="form.real_name" placeholder="请输入助教名称，最多不超过15个字" clearable :maxlength="15"></Input>
        <Button @click="onSelectStudent" icon="ios-add">选择学员</Button>
        <Button @click="onSelectTeacher" icon="ios-add">选择讲师</Button>
      </FormItem>
      <FormItem label="手机号：" prop="mobile">
        <Input
          v-model="form.mobile"
          placeholder="请输入手机号"
          :disabled="disable"
          clearable
          :maxlength="11"
        ></Input>
      </FormItem>
      <FormItem label="助教头像：" prop="avatar">
        <div class="upload-avatar-box">
          <div class="avatar" v-show="form.avatar">
            <img :src="form.avatar" />
          </div>
          <UploadFile
            url="/api/public/img"
            :format="['jpg','jpeg','png']"
            :primary="false"
            note="300*300像素或1:1，支持jpg、jpeg、png,小于5M"
            @onSuccess="onUploadSuccess"
          ></UploadFile>
        </div>
      </FormItem>
      <FormItem label="助教简介：" prop="introduction">
        <Input
          class="introduction"
          type="textarea"
          :rows="4"
          v-model="form.introduction"
          placeholder="请输入助教简介，最多不超过200个字"
          :maxlength="200"
          clearable
        ></Input>
        <CharCount :max="200" :text="form.introduction"></CharCount>
      </FormItem>
      <FormItem>
        <Button class="btn-form btn-margin-right" type="primary" size="large" @click="onSave">保存</Button>
      </FormItem>
    </Form>
    <Modal
      v-model="showSelectStudent"
      title="选择学员"
      class="grid-select"
      @on-ok="onConfirmSelectStudent"
      width="800"
    >
      <StudentSelect ref="student" selectType="single"></StudentSelect>
    </Modal>
    <Modal
      v-model="showSelectTeacher"
      title="选择讲师"
      class="grid-select"
      @on-ok="onConfirmSelectTeacher"
      width="800"
    >
      <TeacherSelect ref="teacher" selectType="single"></TeacherSelect>
    </Modal>
  </div>
</template>

<script>
import StudentSelect from "@/components/GridSelect/StudentSelect";
import TeacherSelect from "@/components/GridSelect/TeacherSelect";
import UploadFile from "@/components/UploadFile";

export default {
  name: "AssistTeacherEdit",
  components: {
    StudentSelect,
    UploadFile,
    TeacherSelect
  },
  data() {
    return {
      form: {
        real_name: "",
        mobile: "",
        avatar: "",
        introduction: ""
      },
      formRules: {
        real_name: [{ required: true, message: "名称不能为空" }],
        mobile: [{ required: true, message: "手机号不能为空" }],
        avatar: [{ required: true, message: "请上传头像！" }],
        introduction: [{ required: true, message: "请输入简介！" }]
      },
      teacherID: this.$route.query.id,
      showSelectStudent: false,
      showSelectTeacher: false,
      disable: false
    };
  },
  created() {
    if (this.teacherID) {
      this.requestDetail();
    }
  },
  methods: {
    onUploadSuccess(data) {
      this.form.avatar = data.path;
    },
    onSelectStudent() {
      this.showSelectStudent = true;
    },
    onSelectTeacher() {
      this.showSelectTeacher = true;
    },
    onConfirmSelectStudent() {
      const list = this.$refs.student.getSelectList();
      if (!list.length) return;
      const data = list[0];
      this.form.real_name = data.nickname;
      this.form.mobile = data.mobile;
      this.form.avatar = data.avatar;
    },
    onConfirmSelectTeacher() {
      const list = this.$refs.teacher.getSelectList();
      if (!list.length) return;
      const data = list[0];
      this.form.real_name = data.real_name;
      this.form.mobile = data.mobile;
      this.form.avatar = data.avatar;
    },
    onAttrChange(val) {
      this.form.teacher_attr = val;
    },
    onSave() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        if (this.teacherID) {
          await this.$http.put("/api/assistant/" + this.teacherID, this.form);
          this.$Message.success("编辑成功");
        } else {
          await this.$http.post("/api/assistant", this.form);
          this.$Message.success("新增成功");
        }
        setTimeout(() => {
          this.$router.back();
        }, 1000);
      });
    },
    async requestDetail() {
      this.form = await this.$http.get("/api/assistant/" + this.teacherID);
    }
  }
};
</script>

<style lang="scss" scoped>
.teacher-edit {
  .form {
    width: 500px;
  }
  .ivu-form-item {
    width: 620px;
    .ivu-form-item-content {
      span {
        float: right;
      }
    }
  }
  .introduction {
    width: 500px;
  }
  .form-name {
    /deep/ .ivu-form-item-content {
      display: flex;
    }
  }
}
</style>
